export const orderDependencyTranslationsEn = {
  overruleExistingLagNotificationTitle:
    'Activity moved due to dependencies | Activities moved due to dependencies',
  overruleExistingLagNotificationDescription:
    'An activity was automatically moved to maintain dependencies to its predecessors. | Some activities were automatically moved to maintain dependencies to their predecessors.',
  overruleExistingLagNotificationAction: 'Adjust dependencies instead',
  overruleNewLagNotificationTitle: 'Activity moved due to dependency',
  overruleNewLagNotificationDescription:
    'The overlap of activities was resolved by moving the successor activity and adjusting the negative dependency.',
  overruleNewLagNotificationAction: 'Restore overlap',
  setNewMinimumDistance: 'Set new minimum distance',
};
